/* Choose-by-breed path for the classic size finder (weight stays first). 2026-10-23. */
(() => {
  const LB = 0.45359237;

  function enhance(finder) {
    if (finder.dataset.breedPath === "ready") return;
    const configNode = finder.querySelector("[data-size-breed-config]");
    const copyNode = finder.querySelector("[data-size-breed-copy]");
    const select = finder.querySelector("[data-size-breed-select]");
    const toggle = finder.querySelector("[data-size-breed-toggle]");
    const pick = finder.querySelector("[data-size-breed-pick]");
    if (!configNode || !copyNode || !select || !toggle || !pick || !window.FourPawSizingV2 || !finder.config) return;
    finder.dataset.breedPath = "ready";

    const breedConfig = JSON.parse(configNode.textContent);
    const copy = JSON.parse(copyNode.textContent);
    const breeds = breedConfig.breeds || [];
    const byName = new Map(breeds.map(b => [b.n, b]));
    const addGroup = (label, names) => {
      const group = document.createElement("optgroup");
      group.label = label;
      names.forEach(name => { if (byName.has(name)) group.append(new Option(name, name)); });
      select.append(group);
    };
    addGroup(copy.popular, breedConfig.popular || []);
    addGroup(copy.all, breeds.map(b => b.n).sort((a, b) => a.localeCompare(b)));
    select.append(new Option(copy.mixed, "__mixed"));

    let mode = "weight";
    let chosenBreed = "";
    const sizes = ["XS", "S", "M", "L", "XL"];
    const range = breed => finder.unit === "kg"
      ? `${breed.kg[0]}–${breed.kg[1]} kg`
      : `${Math.round(breed.kg[0] / LB)}–${Math.round(breed.kg[1] / LB)} lb`;

    toggle.addEventListener("click", () => {
      const open = pick.hidden;
      pick.hidden = !open;
      toggle.setAttribute("aria-expanded", String(open));
    });

    select.addEventListener("change", () => {
      const result = finder.querySelector("[data-size-result]");
      const sizeNode = finder.querySelector("[data-size-result-size]");
      const copyOut = finder.querySelector("[data-size-result-copy]");
      const applyButton = finder.querySelector("[data-size-apply]");
      chosenBreed = "";
      if (!select.value) return;
      mode = "breed";
      if (select.value === "__mixed") {
        finder.canApplyRecommendation = false;
        finder.recommendedSize = "";
        result.hidden = false;
        sizeNode.textContent = "";
        copyOut.textContent = copy.mixedInfo;
        if (applyButton) applyButton.hidden = true;
        finder.weightInput?.focus({ preventScroll: true });
        return;
      }
      const breed = byName.get(select.value);
      if (!breed) return;
      chosenBreed = breed.n;
      if (breed.s && sizes.indexOf(breed.s[1]) - sizes.indexOf(breed.s[0]) >= 2) {
        finder.canApplyRecommendation = false;
        finder.recommendedSize = "";
        result.hidden = false;
        sizeNode.textContent = "";
        copyOut.textContent = copy.breedVaries.replace("{breed}", breed.n).replace("{range}", range(breed));
        if (applyButton) applyButton.hidden = true;
        return;
      }
      const midKg = (breed.kg[0] + breed.kg[1]) / 2;
      const rec = window.FourPawSizingV2.recommend(midKg, finder.config, "", breed.b || 0);
      let size = rec ? rec.finalSize : "";
      if (breed.s && size) {
        const lo = sizes.indexOf(breed.s[0]);
        const hi = sizes.indexOf(breed.s[1]);
        size = sizes[Math.min(Math.max(sizes.indexOf(size), lo), hi)];
      }
      finder.recommendedSize = size;
      finder.canApplyRecommendation = Boolean(size);
      result.hidden = false;
      sizeNode.textContent = size;
      copyOut.textContent = copy.breedBased.replace("{breed}", breed.n).replace("{range}", range(breed));
      if (applyButton) applyButton.hidden = false;
      window.FourPawAnalytics?.publish("fourpaw:size_finder_breed", { breed: breed.n, finalSize: size });
    });

    finder.querySelector("[data-size-calculate]")?.addEventListener("click", () => {
      mode = "weight";
      chosenBreed = "";
      select.value = "";
      const applyButton = finder.querySelector("[data-size-apply]");
      if (applyButton) applyButton.hidden = false;
    });

    const saveToCart = () => {
      if (!finder.recommendedSize) return;
      const kg = finder.lastResult?.weightKg;
      const attributes = {
        "_FP finder size": finder.recommendedSize,
        "_FP breed": mode === "breed" ? chosenBreed : "",
        "_FP dog weight": mode === "weight" && kg ? `${Math.round(kg * 10) / 10} kg` : "",
      };
      fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes }),
      }).catch(() => {});
    };
    finder.querySelector("[data-size-apply]")?.addEventListener("click", saveToCart);
    finder.addEventListener("click", event => {
      if (event.target.closest(".fourpaw-size-finder__feedback button")) saveToCart();
    });
  }

  const run = () => document.querySelectorAll("fourpaw-size-finder").forEach(finder => {
    if (finder.config) enhance(finder);
    else customElements.whenDefined("fourpaw-size-finder").then(() => setTimeout(() => enhance(finder), 0));
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
